import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Leaf } from 'lucide-react';
export function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'submitted'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setStatus('submitted');
      setEmail('');
      setTimeout(() => setStatus('idle'), 3000);
    }
  };
  return <section className="py-24 bg-white" data-id="element-131">
      <div className="max-w-3xl mx-auto px-6 lg:px-12 text-center" data-id="element-132">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col items-center" data-id="element-133">
          <div className="w-16 h-16 bg-brand-mint/20 rounded-full flex items-center justify-center mb-6 text-brand-emerald" data-id="element-134">
            <Leaf size={32} data-id="element-135" />
          </div>

          <h2 className="font-display text-3xl lg:text-4xl font-bold text-brand-charcoal mb-4" data-id="element-136">
            Recibe consejos de bienestar directamente en tu correo
          </h2>

          <p className="text-brand-gray text-lg mb-10 max-w-2xl" data-id="element-137">
            Únete a nuestra comunidad y recibe contenido exclusivo sobre salud
            hormonal, nutrición y bienestar natural. Gratis.
          </p>

          <form onSubmit={handleSubmit} className="w-full max-w-md mx-auto flex flex-col gap-4" data-id="element-138">
            <div className="flex flex-col sm:flex-row gap-3" data-id="element-139">
              <input type="email" placeholder="Tu correo electrónico" required value={email} onChange={e => setEmail(e.target.value)} className="flex-grow px-5 py-3.5 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-brand-emerald/50 focus:border-brand-emerald transition-all" data-id="element-140" />
              <button type="submit" className="bg-brand-emerald text-white px-6 py-3.5 rounded-lg font-medium hover:bg-emerald-900 transition-colors whitespace-nowrap" data-id="element-141">
                {status === 'submitted' ? '¡Suscrito!' : 'Quiero recibir consejos →'}
              </button>
            </div>
            <p className="text-xs text-brand-gray mt-2" data-id="element-142">
              Sin spam. Solo contenido de valor. Puedes cancelar cuando quieras.
            </p>
          </form>
        </motion.div>
      </div>
    </section>;
}